import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { PATH_AUTH } from './paths';

export const ProtectedRoute = ({ children }: any) => {
    const isAuth = useSelector((state: RootState) => state?.auth?.data);
    
    if (!isAuth) {
        return <Navigate to={PATH_AUTH.login} />
    }
    return children;
}